import { ANALYTICS_ITEMS_COUNT, ANALYTICS_PATIENTS_LIST, ANALYTICS_TOP_COUNT } from './constants';
import fetchWithRefresh from './fetchWithRefresh';

export type PatientsByDateResponseType = { count: string; created_at: string }[];

export type NewPatientsByDateResponseType = { count: string; date: string }[];

export type PatientsByDateGenderResponseType = { count: string; date: string }[];

export type TopElementsResponseType = {
    total_pts: string;
    type: string;
    name: string;
    e_rank: string;
    eid: string;
}[];

export type TopSyDyMxLbResponseType = {
    total_pts: string;
    type: string;
    name: string;
    e_rank: string;
}[];

export type TopElementsPtByDateResponseType = {
    rx_count: number;
    created_at: string;
}[];

export type Category = 'sy' | 'dx' | 'drug' | 'lab' | 'patients' | 'ac_class' | 'company' | 'appt';

type AnalyticsTopCountPayload = {
    s_date: string;
    e_date: string;
    category: Category;
    limit: number;
};

export type TopCountResponse = {
    data: {
        [k: string]: {
            eka_id: string;
            name: string;
            rx_count: number | string;
        }[];
    };
};

export const fetchTopCounts = (payload: AnalyticsTopCountPayload): Promise<TopCountResponse> => {
    return fetchWithRefresh(ANALYTICS_TOP_COUNT, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            alert('can not fetch analytics data');
            throw new Error('can not fetch analytics data');
        }
    });
};

export type AnalyticsItemsCountPayload = {
    s_date: string;
    e_date: string;
    category: Category;
    items: string;
};

type ItemsCountResponse = {
    data: {
        [k: string]: {
            created_at: string;
            rx_count: number;
        }[];
    };
};

export const fetchItemsCounts = (
    payload: AnalyticsItemsCountPayload,
): Promise<ItemsCountResponse> => {
    return fetchWithRefresh(ANALYTICS_ITEMS_COUNT, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            alert('can not fetch analytics data');
            throw new Error('can not fetch analytics data');
        }
    });
};

type PatientListResponse = {
    data: {
        eka_d: string;
        pt_details: { age: string; gen: string; name: string; oid: string }[];
    };
};

export const fetchPatientsList = (
    payload: AnalyticsItemsCountPayload,
): Promise<PatientListResponse> => {
    return fetchWithRefresh(ANALYTICS_PATIENTS_LIST, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    }).then((res) => {
        if (res.status === 200) {
            return res.json();
        } else {
            alert('can not fetch analytics data');
            throw new Error('can not fetch analytics data');
        }
    });
};
